/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 20/11/2023
 */

import { apiSlice } from "../Slices/apiSlice";

export const ResourceService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllNoOfResources: builder.query({
      query: () => "/no-res/get-allNoRes",
    }),

    getAllResource: builder.query({
      query: () => "/res",
      providesTags: ["resource"],
    }),

    getResourceById: builder.query({
      query: (resourceId) => `/res/${resourceId}`,
      providesTags: ["resource"],
    }),

    getResCalById: builder.query({
      query: (resourceId) => `/res-cal/res/${resourceId}`,
      providesTags: ["resource"],
    }),

    createResource: builder.mutation({
      query: (Details) => ({
        url: `/res`,
        method: "POST",
        body: Details,
      }),
      invalidatesTags: ["resource"],
    }),

    updateResource: builder.mutation({
      query: (details) => ({
        url: `/res/${details.resourceId}`,
        method: "PUT",
        body: details,
      }),
      invalidatesTags: ["resource"],
    }),

    deleteResource: builder.mutation({
      query: (resourceId) => ({
        url: `/res/${resourceId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["resource"],
    }),

    getResourceBr: builder.query({
      query: () => "",
    }),

    getResourceByArea: builder.query({
      query: (id) => `/res/by-area/${id}`,
    }),

    getResourceByAreaDateTime: builder.query({
      query: (data) => {
        // console.log("Query Parameters ResourceService:", data);
        return `/res/by-cal-slot-area?calId=${data.calId}&slotId=${data.slotId}&areaId=${data.areaId}&catUuid=${data.catId}`;
      },
    }),
    
  }),
});

export const {
  useGetAllNoOfResourcesQuery,
  useGetAllResourceQuery,
  useGetResourceByIdQuery,
  useGetResCalByIdQuery,
  useCreateResourceMutation,
  useUpdateResourceMutation,
  useDeleteResourceMutation,
  useGetResourceByAreaQuery,
  useLazyGetResourceByAreaDateTimeQuery,
} = ResourceService;
